export enum LogicalOperator {
  and = 'and',
  or = 'or'
}
